import { Key } from "../models";

export interface IDataSet
{
    yAxisTitle: string;
    minValue?: number;
    maxValue?: number;
    Baseline?: number;
    sequences: IDataSequence[];
}

export type DotType = 'circle' | 'square';
export enum SequenceState
{
    Normal,
    Dimmed,
    Highlighted,
    Hidden,
}
export interface IDataSequence
{
    id: Key;
    title: string;
    color: string;
    dotType: DotType;
    order: number;
    state: SequenceState;
    baseLine?: boolean;
    dotted?: boolean;
    BaselineValue?: number;
    samples: ISample[];

}

export type Severity = 'red' | 'yellow';
export interface ISample
{
    x: Date;
    y: number;
    severity?: Severity;
}

export interface TooltipInfo
{
    x: Date,
    items: TooltipItem[];
}

export interface TooltipItem
{
    dataSetId: number;
    value: number;
    sequence: IDataSequence;
}


// WEBPACK FOOTER //
// ./src/charts/Data.ts